export default {
    data() {
        return {
            socket: '', //WebSocket
            lockReconnect: false, // 是否真正建立连接
            heartbeatTimeCycle: 20 * 1000, // 定义心跳周期默认为20s
            timeoutObj:'', //心跳心跳倒计时
            serverTimeoutObj: '', //心跳倒计时
            timeoutNum:'',
        }
    },
    destroyed() {
        this.closeWebsocket()
    },
    methods: {
        initWebSocket(fn, url) {
            let weburl = url || this.webSocketUrl
            if (!window.WebSocket) { return }
            if (!this.socket) {
                this.global_callback = fn
                this.socket = new WebSocket(weburl)
                this.socketOnOpen()
                this.socketOnClose()
                this.socketOnError()
                this.socketOnMessage(fn)
            }
        },
        /**
         * 关闭websocket
         */
        closeWebsocket() {
            if (this.socket) {
                this.socket.close()
            }
        },
        socketOnSend(data) {
            if (this.socket.readyState == 1)
                this.socket.send(data)
        },
        socketOnOpen() {
            this.socket.onopen = () => {
                // this.startHeartbeat();
            }
        },
        socketOnClose() {
            this.socket.onclose = () => {}
        },
        socketOnError() {
            this.socket.onerror = () => {
                console.error('ws连接失败')
                this.reconnect()
            }
        },
        socketOnMessage(fn) {
            this.socket.onmessage = (e) => {
                if (e.data.includes("heartbeat")) {
                    this.resetHeartbeat();
                } else {
                    fn(JSON.parse(e.data))
                }
            }
        },
        startHeartbeat() {
            this.timeoutObj && clearTimeout(this.timeoutObj);
            this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
            this.timeoutObj = setTimeout(() => {
                if (this.socket.readyState == 1) {
                    this.socket.send('{"heartbeat":"heartbeat"}');
                } else {
                    this.reconnect();
                }
                this.serverTimeoutObj = setTimeout(() => {
                    this.socket.close();
                }, this.heartbeatTimeCycle);
            }, this.heartbeatTimeCycle);
        },
        resetHeartbeat() {
            //清除时间
            clearTimeout(this.timeoutObj);
            clearTimeout(this.serverTimeoutObj);
            //重启心跳
            // this.startHeartbeat();
        },
        reconnect() {
            if (this.lockReconnect) {
                return;
            }
            this.lockReconnect = true;
            //没连接上会一直重连，设置延迟避免请求过多
            this.timeoutNum && clearTimeout(this.timeoutNum);
            this.timeoutNum = setTimeout(() => {
                this.initWebSocket(this.global_callback);
                this.lockReconnect = false;
            }, 5000);
        }
 
    },
}